import { entity as E } from "./schema.js";
export const media = {
"BB-MED-01": [
E("med_work", "Editorial work", "A persistent editorial or creative work independent of a file rendition.", `catalogue_code|CODE(60)|Publisher-issued work identifier
title|TEXT(250)|Editorial title
work_kind|CODE(30)|Article, program, episode, audio or image
language_code|CODE(20)|Primary language tag
status|CODE(20)|Proposed, commissioned or completed`, ["catalogue_code"], "Work identity is separate from title text, edition and binary file identity."),
E("med_edition", "Work edition", "An editorial revision or edition of a work.", `work_id|>med_work.id|Underlying work
edition_number|INTEGER|Edition sequence
headline|TEXT(250)|Edition-specific headline
prepared_at|INSTANT|Editorial preparation time
editorial_status|CODE(20)|Draft, reviewed or approved`, ["work_id,edition_number"], "Approved editions should retain their editorial history."),
E("med_contribution", "Work contribution", "A credited party's contribution to a creative work.", `work_id|>med_work.id|Creative work
party_id|>pty_party.party_id|Contributor identity
role_code|CODE(40)|Author, editor, performer or producer
credit_order|INTEGER|Display order
credit_text|TEXT(200)|Agreed displayed credit`, ["work_id,party_id,role_code"], "Credit is not ownership or a license grant."),
E("med_work_topic", "Work topic assignment", "A controlled subject classification for a work.", `work_id|>med_work.id|Classified work
vocabulary|CODE(60)|Topic vocabulary and version
topic_code|CODE(80)|Vocabulary term
is_primary|BOOL|Primary editorial topic flag`, ["work_id,vocabulary,topic_code"], "Classifications retain the vocabulary version rather than only free-text labels.")
],
"BB-MED-02": [
E("med_production", "Media production plan", "A production effort for a work with an explicit budget and schedule.", `work_id|>med_work.id|Planned work
project_id|>prj_project.project_id|Shared project
production_code|CODE(50)|Production reference
planned_start|DATE|Production start
planned_finish|DATE|Production completion
budget|MONEY|Approved budget
currency|CODE(3)|Budget currency`, ["production_code"], "Project tasks and employee identity are reused through shared blocks."),
E("med_production_booking", "Production crew booking", "A contributor booked for a dated production activity.", `production_id|>med_production.id|Production plan
party_id|>pty_party.party_id|Crew member or service company
booking_no|INTEGER|Booking sequence
role_code|CODE(40)|Production role
starts_at|INSTANT|Booking start
ends_at|INSTANT|Booking end`, ["production_id,booking_no"], "Availability and contractual acceptance are separate from a planned booking."),
E("med_deliverable", "Production deliverable", "An expected editorial deliverable and its acceptance record.", `production_id|>med_production.id|Production plan
deliverable_code|CODE(40)|Deliverable within production
edition_id|>med_edition.id?|Delivered edition
due_on|DATE|Due date
acceptance_status|CODE(20)|Expected, received or accepted`, ["production_id,deliverable_code"], "Receipt alone does not imply editorial or contractual acceptance.")
],
"BB-MED-03": [
E("med_license", "Media license agreement", "An agreement granting specified rights from a shared party.", `licensor_id|>pty_party.party_id|Rights-granting party
agreement_reference|CODE(60)|License agreement identifier
signed_on|DATE|Agreement date
valid_from|DATE|Start of rights window
valid_to|DATE|End of rights window`, ["licensor_id,agreement_reference"], "Rights ownership and territorial interpretation require legal review."),
E("med_rights_grant", "Licensed use grant", "A work, territory and channel usage right within an agreement.", `license_id|>med_license.id|Governing license
work_id|>med_work.id|Licensed work
grant_no|INTEGER|Agreement grant sequence
territory_code|CODE(40)|Explicit territory vocabulary
channel_code|CODE(40)|Permitted distribution channel
use_code|CODE(40)|Permitted use
exclusive|BOOL|Declared exclusivity`, ["license_id,grant_no"], "A grant cannot extend beyond the agreement window; rights conflicts require review."),
E("med_rights_restriction", "Licensed-use restriction", "A condition constraining a particular rights grant.", `grant_id|>med_rights_grant.id|Constrained grant
restriction_no|INTEGER|Condition sequence
restriction_kind|CODE(40)|Holdback, frequency, editing or attribution
condition_text|TEXT(1500)|Approved contractual condition`, ["grant_id,restriction_no"], "Free-text conditions are preserved and not treated as executable policy.")
],
"BB-MED-04": [
E("med_channel", "Publication channel", "A named owned or partner publication destination.", `channel_code|CODE(40)|Publisher-scoped channel identifier
channel_name|TEXT(150)|Channel label
channel_kind|CODE(30)|Web, print, broadcast, app or partner
time_zone|TEXT(80)|Scheduling time zone`, ["channel_code"], "Channel identity is independent of a transient endpoint URL."),
E("med_release", "Content release", "An edition scheduled for publication on a channel.", `edition_id|>med_edition.id|Published edition
channel_id|>med_channel.id|Destination channel
release_reference|CODE(50)|Release identifier
scheduled_at|INSTANT|Scheduled publication time
status|CODE(20)|Scheduled, live or withdrawn`, ["release_reference"], "Publication must check effective rights and editorial approval."),
E("med_release_event", "Publication status event", "A recorded publication or withdrawal event.", `release_id|>med_release.id|Content release
event_no|INTEGER|Status sequence
occurred_at|INSTANT|Actual event time
status|CODE(20)|Published, corrected or withdrawn
reason|TEXT(500)?|Change rationale`, ["release_id,event_no"], "Withdrawal preserves original publication history.")
],
"BB-MED-05": [
E("med_delivery_package", "Content delivery package", "An edition packaged for a distribution partner.", `edition_id|>med_edition.id|Content edition
package_reference|CODE(60)|Package identifier
partner_id|>pty_party.party_id|Receiving partner
format_code|CODE(30)|Agreed delivery format
prepared_at|INSTANT|Package creation time`, ["package_reference"], "Package metadata is not a claim of conformance to a delivery standard."),
E("med_delivery_attempt", "Content delivery attempt", "A transmission attempt to a partner destination.", `package_id|>med_delivery_package.id|Transmitted package
attempt_no|INTEGER|Attempt sequence
destination_reference|TEXT(200)|Configured destination identifier
sent_at|INSTANT|Transmission timestamp
status|CODE(20)|Sent, failed or acknowledged`, ["package_id,attempt_no"], "Retries retain the same package identity and separate attempt IDs."),
E("med_delivery_ack", "Distribution acknowledgement", "A partner acknowledgement for a delivery attempt.", `attempt_id|>med_delivery_attempt.id|Acknowledged attempt
partner_reference|CODE(100)|Partner acknowledgement identifier
received_at|INSTANT|Acknowledgement timestamp
outcome|CODE(20)|Accepted or rejected
message|TEXT(500)?|Partner response detail`, ["attempt_id,partner_reference"], "Transmission success and editorial acceptance remain separate.")
],
"BB-MED-06": [
E("med_campaign", "Advertising campaign", "An advertiser campaign with agreed dates and budget.", `advertiser_id|>pty_party.party_id|Advertiser identity
campaign_reference|CODE(50)|Campaign identifier
starts_on|DATE|Campaign start
ends_on|DATE|Campaign end
budget|MONEY|Campaign budget
currency|CODE(3)|Budget currency`, ["campaign_reference"], "Budget does not imply guaranteed delivery or billing."),
E("med_placement", "Advertising placement", "Booked advertising space or time on a publication channel.", `campaign_id|>med_campaign.id|Campaign
channel_id|>med_channel.id|Placement channel
placement_no|INTEGER|Placement sequence
creative_work_id|>med_work.id|Creative work
booked_units|QTY|Booked delivery units
unit_kind|CODE(30)|Impressions, spots or insertions`, ["campaign_id,placement_no"], "Audience estimates are not delivered units."),
E("med_ad_delivery", "Advertising delivery record", "Measured delivery and charge evidence for a placement.", `placement_id|>med_placement.id|Advertising placement
measurement_date|DATE|Delivery date
source_reference|CODE(80)|Measurement source identifier
delivered_units|QTY|Measured delivery
charge_amount|MONEY|Assessed charge in campaign currency`, ["placement_id,measurement_date,source_reference"], "Fraud filtering, measurement definitions and charge approval require explicit policy.")
],
"BB-MED-07": [
E("med_subscription_plan", "Media subscription plan", "A versioned offer for access to a publication channel.", `channel_id|>med_channel.id|Primary publication channel
plan_code|CODE(40)|Offer identifier
version|INTEGER|Offer version
billing_period|CODE(20)|Monthly, annual or fixed
price|MONEY|Period price
currency|CODE(3)|Price currency`, ["plan_code,version"], "Taxes, discounts and renewal consent are separate rules."),
E("med_subscription", "Media subscription", "A subscriber's dated agreement for a plan.", `party_id|>pty_party.party_id|Subscriber
plan_id|>med_subscription_plan.id|Offer version
subscription_reference|CODE(60)|Subscription identifier
starts_on|DATE|Access start
ends_on|DATE?|Access end
status|CODE(20)|Active, paused or cancelled`, ["subscription_reference"], "Cancellation and end of paid access may occur on different dates."),
E("med_entitlement", "Media access entitlement", "A channel-specific access grant arising from a subscription.", `subscription_id|>med_subscription.id|Source subscription
channel_id|>med_channel.id|Accessible channel
valid_from|INSTANT|Access starts
valid_to|INSTANT|Access expires
access_tier|CODE(30)|Granted access level`, ["subscription_id,channel_id,valid_from"], "Entitlements are modeled records; no authentication or paywall runtime is supplied.")
],
"BB-MED-08": [
E("med_audience_segment", "Audience segment", "A versioned definition for aggregated audience analysis.", `segment_code|CODE(40)|Segment identifier
version|INTEGER|Definition version
definition|TEXT(1500)|Reviewed segment criteria
measurement_basis|CODE(30)|Consented_cohort or aggregate`, ["segment_code,version"], "Segment criteria require a privacy review before using personal attributes."),
E("med_consumption", "Content consumption aggregate", "A time-bucketed aggregate of content consumption.", `release_id|>med_release.id|Published content
segment_id|>med_audience_segment.id|Audience definition
bucket_start|INSTANT|Aggregation start
bucket_end|INSTANT|Aggregation end
views|INTEGER|Qualified view count
duration_seconds|QTY|Aggregate consumed duration`, ["release_id,segment_id,bucket_start"], "No individual browsing identifiers are included; metric definitions require provenance."),
E("med_campaign_response", "Campaign response aggregate", "Aggregated interactions attributed to an advertising placement.", `placement_id|>med_placement.id|Advertising placement
segment_id|>med_audience_segment.id|Audience segment
measured_on|DATE|Measurement date
clicks|INTEGER|Attributed click count
conversions|INTEGER|Attributed conversion count
attribution_rule|CODE(60)|Rule version`, ["placement_id,segment_id,measured_on,attribution_rule"], "Attribution does not establish causation; source rules must avoid duplicate counting.")
],
"BB-MED-09": [
E("med_asset", "Digital media asset", "A managed binary asset associated with a creative work.", `work_id|>med_work.id|Editorial work
asset_reference|CODE(60)|Digital asset identifier
media_kind|CODE(30)|Image, audio, video or document
created_at|INSTANT|Asset ingestion timestamp`, ["asset_reference"], "Digital asset identity remains separate from storage location."),
E("med_asset_version", "Digital asset version", "A checksum-identified version of a managed asset.", `asset_id|>med_asset.id|Digital asset
version|INTEGER|Version sequence
checksum_algorithm|CODE(20)|Digest algorithm
checksum|CODE(150)|Digest value
byte_size|QTY|Binary size in bytes
storage_reference|TEXT(500)|Managed storage locator`, ["asset_id,version"], "Storage references contain no embedded credentials; byte size must be an integer."),
E("med_rendition", "Media rendition", "A delivery rendition generated from an asset version.", `version_id|>med_asset_version.id|Source binary version
profile_code|CODE(60)|Transformation profile version
mime_type|TEXT(100)|Media type
width_pixels|INTEGER?|Image or video width
height_pixels|INTEGER?|Image or video height
duration_seconds|QTY?|Audio or video duration
storage_reference|TEXT(500)|Rendition storage locator`, ["version_id,profile_code"], "Renditions remain traceable to immutable source versions.")
],
"BB-MED-10": [
E("med_equipment_booking", "Production equipment booking", "A scheduled use of a shared physical asset.", `asset_id|>ast_asset.asset_id|Camera, studio or production asset
production_id|>med_production.id|Using production
booking_reference|CODE(50)|Reservation identifier
starts_at|INSTANT|Reservation start
ends_at|INSTANT|Reservation end`, ["booking_reference"], "Incompatible overlapping bookings must be prevented by scheduling logic."),
E("med_equipment_handover", "Equipment custody handover", "A recorded physical handover associated with a booking.", `booking_id|>med_equipment_booking.id|Equipment booking
sequence_no|INTEGER|Custody event sequence
party_id|>pty_party.party_id|Receiving custodian
handed_at|INSTANT|Handover time
condition_text|TEXT(500)|Observed condition`, ["booking_id,sequence_no"], "Damage records and maintenance decisions require review."),
E("med_supply_usage", "Production consumables usage", "An inventory issue for a media production.", `production_id|>med_production.id|Consuming production
movement_id|>inv_movement.movement_id|Shared inventory movement
purpose|TEXT(200)|Production use
recorded_at|INSTANT|Usage reference timestamp`, ["production_id,movement_id"], "Consumable quantities remain in the shared inventory movement ledger.")
],
"BB-MED-11": [
E("med_service_contract", "Media service contract", "A supplier or freelance agreement for production services.", `supplier_id|>sup_account.supplier_id|Service supplier
production_id|>med_production.id|Commissioning production
contract_reference|CODE(60)|Contract identifier
currency|CODE(3)|Contract currency
agreed_amount|MONEY|Contract ceiling`, ["contract_reference"], "Employment classification and rights ownership require contractual review."),
E("med_service_order", "Media service order", "A commissioned deliverable under a service contract.", `contract_id|>med_service_contract.id|Service agreement
order_no|INTEGER|Order sequence
deliverable_id|>med_deliverable.id|Expected deliverable
due_on|DATE|Agreed delivery date
amount|MONEY|Agreed charge in contract currency`, ["contract_id,order_no"], "A delivery plan is not evidence of completion or entitlement to payment."),
E("med_service_acceptance", "Media service acceptance", "An approved service-delivery and invoice reference.", `order_id|>med_service_order.id|Service order
acceptance_no|INTEGER|Acceptance sequence
accepted_on|DATE|Acceptance date
invoice_reference|TEXT(120)?|Supplier invoice reference
accepted_amount|MONEY|Approved amount in contract currency`, ["order_id,acceptance_no"], "Partial acceptances must reconcile against contracted value.")
],
"BB-MED-12": [
E("med_royalty_statement", "Royalty settlement statement", "A statement of assessed royalties under a media license.", `license_id|>med_license.id|Rights agreement
statement_number|CODE(60)|Statement reference
period_start|DATE|Settlement period start
period_end|DATE|Settlement period end
currency|CODE(3)|Settlement currency`, ["license_id,statement_number"], "Royalty rates, permitted deductions and audit rights are contract-specific."),
E("med_royalty_line", "Royalty calculation line", "Recorded usage and an assessed royalty for a licensed work.", `statement_id|>med_royalty_statement.id|Royalty statement
line_no|INTEGER|Calculation sequence
work_id|>med_work.id|Licensed work
usage_quantity|QTY|Measured usage
usage_unit|CODE(30)|Measurement unit such as copies, views or minutes
calculation_basis|TEXT(500)|Reviewed royalty calculation
amount|MONEY|Assessed royalty`, ["statement_id,line_no"], "This retains a reviewed calculation; it is not a royalty calculation engine."),
E("med_financial_allocation", "Media finance allocation", "A ledger posting attributed to a work and its commercial source.", `work_id|>med_work.id|Costed or revenue-producing work
journal_id|>fin_journal.journal_id|Approved ledger journal
source_reference|CODE(100)|Revenue, cost or settlement reference
allocation_kind|CODE(30)|Sales, advertising, production_cost or royalty
amount|MONEY|Allocated value
currency|CODE(3)|Allocation currency`, ["work_id,journal_id,source_reference"], "Allocation totals must reconcile to journals without duplicate revenue recognition.")
]
};
